class MForm {
	/** @param {HTMLFormElement} element */
	constructor(element) {
		this.element = element;
		this.errorElement = element.querySelector('.m-form__error');

		element.addEventListener('submit', this.submitForm.bind(this));
	}

	resetFormErrors() {
		const { element } = this;
		const { elements } = element;
		[...elements].forEach((itemElement) => {
			const fieldElement = itemElement.closest('.m-field');
			if (fieldElement) {
				fieldElement.querySelector('.m-field__error').innerText = '';
			}
		});
	}

	showFormErrors(errors) {
		const { element } = this;
		const { elements } = element;
		Object.keys(errors).forEach((errorKey) => {
			if (elements[errorKey]) {
				elements[errorKey].closest('.m-field').querySelector('.m-field__error').innerText = errors[errorKey];
			} else {
				this.errorElement.innerText = errors[errorKey];
				console.error(errorKey, errors[errorKey]);
			}
		});
	}

	showSuccess(successMessage) {
		const {
			element,
		} = this;
		const successElement = Object.assign(document.createElement('div'), {
			className: 'm-form__success-text',
			innerHTML: successMessage,
		});

		element.classList.add('-success');

		element.querySelector('.a-button').remove();
		element.appendChild(successElement);
	}

	/**
	 * @param {SubmitEvent} event
	 */
	submitForm(event) {
		event.preventDefault();

		const { element } = this;
		const formData = new FormData(element);
		element.classList.add('-loading');
		this.resetFormErrors();

		// Disable form elements
		Array.from(element).forEach((itemElement) => {
			Object.assign(itemElement, {
				disabled: true,
			});
		});

		fetch(element.action, {
			method: element.method,
			body: formData,
		}).then((response) => {
			if (response.ok) {
				return response.json();
			}
			throw new Error('Something went wrong');
		}).then((data) => {
			if (data.success === true) {
				this.showSuccess(data.successMessage);
			} else if (data.errors) {
				this.showFormErrors(data.errors);
			}
		}).catch((error) => console.error(error))
			.finally(() => {
				element.classList.remove('-loading');
				if (!element.classList.contains('-success')) {
					// Enable form elements
					Array.from(element).forEach((itemElement) => {
						Object.assign(itemElement, {
							disabled: false,
						});
					});
				}
			});
	}
}

// Only forms posting to /api/form, other .m-form forms
// (e.g. request product popup) have their own submit handler
document.querySelectorAll('.m-form[action$="/api/form"]').forEach((_) => new MForm(_));
